import { Checkbox, FormControlLabel } from "@mui/material";
import React from "react";
import { Attachment } from "../attachments/helpers.js";
import { AllowedValueLabelWithOverride } from "./AllowedValueLabelWithOverride.js";
import { AllowedValue, PropType } from "./properties.js";

export function AllowedValueFormControlLabelWithOverride({
  checked,
  overriddenMedia,
  valueAsString,
  onAllowedValueMediaChange,
  onAllowedValueChange,
  propAllowedValue,
  propertyType,
}: {
  checked: boolean;
  valueAsString: string;
  overriddenMedia: Attachment | null | undefined;
  onAllowedValueMediaChange: (
    valueAsString: string,
    media: Attachment | null | undefined
  ) => Promise<void>;
  onAllowedValueChange: (
    checked: boolean,
    allowedValue: AllowedValue
  ) => Promise<void>;
  propAllowedValue: AllowedValue;
  propertyType: PropType;
}) {
  return (
    <FormControlLabel
      sx={{ mr: 0 }}
      control={
        <Checkbox
          checked={checked}
          onChange={async e => {
            await onAllowedValueChange(e.target.checked, propAllowedValue);
          }}
        />
      }
      slotProps={{ typography: { sx: { flex: 1 } } }}
      label={
        <AllowedValueLabelWithOverride
          overriddenMedia={overriddenMedia}
          valueAsString={valueAsString}
          onValueMediaChange={onAllowedValueMediaChange}
          propertyType={propertyType}
          media={propAllowedValue.media}
          value={propAllowedValue.value}
        />
      }
    />
  );
}
